export default "__VITE_ASSET__DDG5OoiP__"